export const COMPONENT_NAME = 'PushNotifications';
export const LS_TIME_KEY = `${COMPONENT_NAME}:nextTime`;
export const LS_HAS_USER_UNSUBSCRIBED_KEY = `${COMPONENT_NAME}:unsubscribed`;
export const PERMISSION_GRANTED = 'granted';
export const SCP_COOKIE_PARAM = 'skipNotificationsTo';

export const PLACEMENT_MOBILE_TOP = 64;
export const PLACEMENT_DESKTOP_TOP = 8;
export const PLACEMENT_DESKTOP_LEFT = 120;

/* 
  1/3 экрана 
*/
export const DEFAULT_THRESHOLD = 3;

export const ERRORS = {
  TIMEMARK_HAS_BEEN_SET: {
    message: 'Временная отметка',
    code: 'time_mark',
  },
  TIMEMARK_DELTA_INVALID: {
    message: 'Некорректное значение метки',
  },
};

export const MODEL_PARAMS_DEFAULT = {
  timeMarkDelta: 36e5 * 24 * 7, // 7 дней
  useLocalStorageTimemark: true,
  isEnabled: true,
};

export const TIMEOUTS = {
  INITIALIZATION: 9e4,
};
